import React, { useState } from "react";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../../../components/Modals/CustomModal";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import {
  EMITTER_ERROR,
  EMITTER_SUCCESS,
} from "../../../../utils/constants";
import { CampaignSettingsEndpoints } from "../../../../utils/constants/httpConstants";
import { deleteRequest } from "../../../../Apis/apiWrapper";
import { getErrorMessage } from "../../../../utils/helpers";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import { STRINGS } from "../../../Marketing/strings";

const DeleteSignatureModal = ({ open, onClose, onDeleted, signature }) => {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!signature?._id) return;
    try {
      setIsDeleting(true);
      const response = await deleteRequest(
        `${CampaignSettingsEndpoints.signatureDelete}/${signature._id}`,
      );
      const apiMessage = response?.data?.message;
      const isHelpful =
        typeof apiMessage === "string" &&
        apiMessage.trim() &&
        !/^\s*(ok|200)\s*$/i.test(apiMessage);
      EventEmitter.emit(
        EMITTER_SUCCESS,
        isHelpful ? apiMessage : "Signature deleted successfully",
      );
      onDeleted?.();
      onClose?.();
    } catch (err) {
      EventEmitter.emit(
        EMITTER_ERROR,
        getErrorMessage(err?.data?.data?.errors || {}, err?.data?.message),
      );
    } finally {
      setIsDeleting(false);
    }
  };

  const modalHeaderData = {
    heading: {
      id: "delete-signature",
      label: STRINGS.DELETE_SIGNATURE_TITLE,
    },
    alertIcon: {
      id: "delete-icon",
      label: ICON_LABELS.DELETE,
    },
  };

  const modalBodyData = (
    <Box sx={{ padding: "4px 16px 16px 16px" }}>
      <TypographyInline
        size={"md"}
        color={GREY.PRIMARY}
        fontWeight={fontWeight.SEMIBOLD}
        label={signature?.signature_name || STRINGS.DELETE_SIGNATURE_TITLE}
      />
      <TypographyInline
        size={"xs"}
        color={GREY.SECONDARY}
        fontWeight={fontWeight.REGULAR}
        label={STRINGS.DELETE_SIGNATURE_CONFIRM}
      />
    </Box>
  );

  const modalFooterRightData = (
    <Box sx={{ display: "flex", gap: "8px" }}>
      <Button
        label={STRINGS.CANCEL}
        size={"sm36"}
        variant={"ghost"}
        onClick={onClose}
      />
      <Button
        label={STRINGS.DELETE}
        size={"sm36"}
        variant={"primary"}
        onClick={handleDelete}
        isLoading={isDeleting}
      />
    </Box>
  );

  return (
    <CustomModal
      open={open}
      close={onClose}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{ left: <div />, right: modalFooterRightData }}
      variant={"alert"}
      remove_padding
    />
  );
};

export default DeleteSignatureModal;
